import { BareButton, Button } from "@setel/web-ui";
import { SkeletonItem } from "~/lib/components/ui/SkeletonItem";
import { LocaleLink } from "~/lib/components/link";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "~/lib/utils/store/useTranslation";
import { useGetAllVideosSetel } from "../../../../services/queries/onbroading.queries";
import { IOnboardDingPlaylistResponseField } from "~/lib/types/onboarding.videos.type";
import { SwiperComponent } from "../../navigation/Swiper";
import { PLAYLIST_KEY_TUTORIAL_VIDEOS_SEQUENCES } from "~/lib/utils/const";
import { getTranslationVideoName } from "~/lib/utils/helper/getTranslationVideoName";

const TutorialVideos = () => {
  const { t, i18n } = useTranslation();
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const [playlistVideos, setPlaylistVideos] = useState<
    IOnboardDingPlaylistResponseField[]
  >([]);
  const [indexVideo, setIndexVideo] = useState<number>(0);
  const {
    data: tutorialVideos,
    isLoading,
    refetch,
  } = useGetAllVideosSetel(false);

  useEffect(() => {
    refetch();
  }, [refetch]);
  useEffect(() => {
    if (!isLoading && tutorialVideos) {
      const validPlaylist = tutorialVideos
        .filter((playlist) => {
          return playlist.videos.length !== 0;
        })
        .splice(0, 7);
      setPlaylistVideos(validPlaylist);
    }
  }, [tutorialVideos, isLoading]);
  const sortPlaylistVideos = useMemo(() => {
    const newPlaylist = playlistVideos.sort((a, b) => {
      const indexA = PLAYLIST_KEY_TUTORIAL_VIDEOS_SEQUENCES.indexOf(
        a.playlistKey
      );
      const indexB = PLAYLIST_KEY_TUTORIAL_VIDEOS_SEQUENCES.indexOf(
        b.playlistKey
      );
      if (indexA === -1) {
        return 1;
      }
      if (indexB === -1) {
        return -1;
      }
      return indexA - indexB;
    });
    return newPlaylist;
  }, [playlistVideos]);
  useEffect(() => {
    setPlaylistVideos(sortPlaylistVideos);
  }, [playlistVideos]);

  return (
    <>
      {playlistVideos && (
        <>
          <div className="mx-auto w-full max-w-screen-md md:max-w-8xl">
            <div className="flex px-5 md:px-0 justify-between items-center mb-5">
              <p className="font-semibold text-xl font-title">
                {t("tutorialVideos")}
              </p>

              <LocaleLink to="/tutorial-videos">
                <BareButton className="font-medium text-base">
                  {t("viewAll")}
                </BareButton>
              </LocaleLink>
            </div>
            <div className="overflow-x-auto lg:overflow-hidden min-h-[122px]">
              <div className="flex flex-row pl-5 md:pl-0 md:grid md:grid-cols-7 gap-[10px] sm:gap-4 min-w-[802px]">
                {isLoading ? (
                  <SkeletonItem count={3} />
                ) : (
                  playlistVideos.map((playlist, index) => {
                    return (
                      <div
                        key={playlist.name}
                        className="max-w-[154px] col-span-1"
                        onClick={() => {
                          setIsShowModal(true);
                          setIndexVideo(index);
                        }}
                      >
                        <div className="rounded-lg relative w-[154px] h-[168px] md:w-auto overflow-hidden">
                          <img
                            className="rounded-lg w-[154px] h-[168px] object-cover"
                            src={playlist.thumbnailUrl}
                          />
                          <div className="absolute rounded-lg top-0 left-0 z-10 w-full h-full icons-swiper flex justify-center items-center">
                            <span>
                              <svg
                                width="17"
                                height="18"
                                viewBox="0 0 17 18"
                                fill="none"
                              >
                                <path
                                  d="M0.1875 14.8342V3.16752C0.1875 1.28021 2.1987 0.0734913 3.86397 0.961633L14.8015 6.79497C16.5662 7.73614 16.5662 10.2656 14.8015 11.2067L3.86397 17.0401C2.1987 17.9282 0.1875 16.7215 0.1875 14.8342Z"
                                  fill="white"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                        <div className="text-sm font-medium pt-2 line-clamp-2">
                          {getTranslationVideoName(playlist, i18n.language)}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>

          {isShowModal && (
            <div className="fixed z-100 top-0 left-0 right-0 bottom-0 flex flex-col bg-shaded">
              <div className="absolute top-8 right-6 z-100">
                <Button
                  type={"button"}
                  className="px-[9px] h-[34px] rounded-[50%] bg-black bg-opacity-50 border-none btn-close-image"
                  onClick={() => {
                    setIsShowModal(false);
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.44621 0.397052L1.53033 0.46967L8 6.939L14.4697 0.46967C14.7626 0.176777 15.2374 0.176777 15.5303 0.46967C15.7966 0.735936 15.8208 1.1526 15.6029 1.44621L15.5303 1.53033L9.061 8L15.5303 14.4697C15.8232 14.7626 15.8232 15.2374 15.5303 15.5303C15.2641 15.7966 14.8474 15.8208 14.5538 15.6029L14.4697 15.5303L8 9.061L1.53033 15.5303C1.23744 15.8232 0.762563 15.8232 0.46967 15.5303C0.203403 15.2641 0.179197 14.8474 0.397052 14.5538L0.46967 14.4697L6.939 8L0.46967 1.53033C0.176777 1.23744 0.176777 0.762563 0.46967 0.46967C0.706351 0.232989 1.06186 0.187565 1.34416 0.333399L1.44621 0.397052Z"
                      fill="white"
                    />
                  </svg>
                </Button>
              </div>

              <SwiperComponent
                indexVideo={indexVideo}
                videos={playlistVideos}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default TutorialVideos;
